import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";

const categories = [
  {
    icon: "ri-movie-2-line",
    title: "最新上映",
    desc: "近期登陆穹顶厅的新片与重制版本",
    to: "/films?sort=newest",
    accent: "bg-primary-500",
  },
  {
    icon: "ri-fire-line",
    title: "热门影片",
    desc: "观影人次最高的沉浸式口碑之作",
    to: "/films?sort=popular",
    accent: "bg-accent-500",
  },
  {
    icon: "ri-planet-line",
    title: "特色球幕片",
    desc: "为 360 度穹顶专门制作的沉浸影像",
    to: "/films?tag=%E7%90%83%E5%B9%95%E6%8A%80%E6%9C%AF",
    accent: "bg-secondary-500",
  },
];

export default function CategoryCards() {
  return (
    <section className="max-w-content mx-auto px-4 md:px-8 py-16 md:py-20">
      <div className="mb-10">
        <p className="text-xs font-label tracking-widest text-accent-500 uppercase mb-3">Explore</p>
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">快捷分类入口</h2>
        <p className="text-sm text-foreground-600 mt-3 max-w-2xl">
          按你的观影偏好快速找到合适的穹顶影片，从最新上映到口碑热门，一站直达。
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {categories.map((cat, i) => (
          <Reveal key={cat.title} delay={i * 90}>
            <Link
              to={cat.to}
              className="group block h-full p-6 rounded-lg bg-background-100 border border-background-200/70 hover:border-accent-500/60 transition-colors cursor-pointer"
            >
              <span
                className={`w-12 h-12 flex items-center justify-center rounded-lg ${cat.accent} text-background-50 text-2xl mb-5`}
              >
                <i className={cat.icon} />
              </span>
              <h3 className="font-heading font-semibold text-lg text-foreground-950 mb-2">{cat.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-5">{cat.desc}</p>
              <span className="inline-flex items-center gap-1.5 text-sm font-label text-accent-500">
                进入分类
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
              </span>
            </Link>
          </Reveal>
        ))}
      </div>
    </section>
  );
}